export default {
  'cookie-banner:title': 'Voordat je verder shopt…',
  'cookie-banner:subtitle':
    'Pets Deli gebruikt cookies om je de best mogelijke service te bieden. Door de site te gebruiken ga je akkoord met het gebruik van cookies.',
  'cookie-banner:privacy-text':
    'Op de pagina { privacyProtectionLink } kun je altijd nalezen hoe en waarvoor we je gegevens gebruiken.',
  'cookie-banner:privacy-link': 'Privacybeleid',
  'cookie-banner:button': 'Oké, verder naar de shop',
};
